import React, { Component } from "react";
import { withTranslation } from "react-i18next";
/* components */
import { default as ToBeDashboard } from "../../components_v2/dashboard";

class Dashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            contentIndex: 0,
            projectIndex: 0,
        };
    }
    render() {
        return (
            <React.Fragment>
                <ToBeDashboard />
            </React.Fragment>
        );
    }
}

export default withTranslation()(Dashboard);
